<template>
  <header id="header"
          class="header align-self-start w-100">
    <b-navbar toggleable="sm"
              class="header_content">
      <b-navbar-brand v-if="module.logo"
                      :to="{ name: 'rei_dashboard' }">
        <svg class="header_logo icon logo_rei"
             role="presentation">
          <use :xlink:href="'#' + module.logo.id" />
        </svg>
      </b-navbar-brand>

      <button v-b-tooltip.hover.right="getSidebarStatus ? '' : 'Abrir menu'"
              v-ripple
              class="header_menuWrap d-inline-block ml-3 mt-2 border-0 position-relative"
              :class="{ 'isActive': getSidebarStatus }"
              type="button"
              @click="openSidebar">
        <svg class="header_menuIcon icon--sm"
             role="presentation">
          <use :xlink:href="'#' + menuIcon.id" />
        </svg>
      </button>

      <div class="ml-auto d-inline-block pr-4">
        <!-- <SelecionarCartorio /> -->
        <u>Cartório Atual</u>
        <br>
        <select class="form-control form-control-sm classcart"
                @change="changeCartorio">
          <option v-for="cartorio in userCartorios"
                  :key="cartorio.user_id"
                  :value="cartorio.user_id"
                  :selected="cartorio.cartorio_id == cartorioId">
            {{ cartorio.cns }} - {{ cartorio.nome }}
          </option>
        </select>
      </div>
      <!-- Gerenciador de tarefas será exibido na parte lateral direita do Dashboard. Componente SideBarReleasesNotes. -->

      <MenuModules />

      <div class="d-inline-block">
        <UserHeaderInfo />
      </div>

      <b-navbar-brand class="d-none d-sm-block">
        <svg class="header_logo icon"
             role="presentation">
          <use :xlink:href="'#' + sofiaLogo.id" />
        </svg>
      </b-navbar-brand>
      <ReleasesNotes />
    </b-navbar>
  </header>
</template>

<script>
  import { mapGetters } from "vuex"
  import menuIcon from "@/assets/icons/menu-button.svg?sprite"
  import UserHeaderInfo from "./UserHeaderInfo"
  import sofiaLogo from "@/assets/icons/logo-sofia.svg?sprite"
  import ReleasesNotes from "@/components/SofiaRei/ReleasesNotes/ReleasesNotes.vue"

  import { acessarCartorio } from "@/helpers/usuario"

  import MenuModules from "@/components/MenuModules"

  export default {
    name: 'AppHeader',
    components: {
      UserHeaderInfo,
      MenuModules,
      ReleasesNotes,
    },
    props: ['module'],
    data () {
      return {
        menuIcon,
        sofiaLogo,
        qtdTarefasPendentes: null
      }
    },
    computed: {
      ...mapGetters({
        getSidebarStatus: "auth/isSidebarOpen",
        cartorioId: "auth/getCartorioId",
        userCartorios: "auth/getUserCartorios",
        socket: 'webSockets/getInfo',
        user: 'auth/getUser'
      })

    },
    methods: {
      openSidebar (e) {
        this.$store
          .dispatch("auth/openSidebar", !this.getSidebarStatus)
          .then(res => res)
        return e.target.blur()
      },
      async changeCartorio (event) {
        const userId = event.target.value
        const cartorios = this.userCartorios
        try {
          await acessarCartorio(cartorios, userId)
          return window.location.reload()
        } catch (e) {
          const { message } = getErrors(e)
          displayMessage('error', 'Erro', message)
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "../scss/_utilities/exports";

  .header {
    background-color: $color-light;
    // box-shadow: 0 0 pxToRem(6) $color-gray;
    left: 0;
    height: 70px !important;
    margin-bottom: pxToRem(20);
    position: fixed;
    right: 0;
    top: 0;
    z-index: 100;

    &_logo {
      height: pxToRem(40) !important;
    }
    .classcart {
    background-color: transparent;
    border: none;

  }

    &_menuWrap {
      background-color: transparent;
      border-radius: pxToRem(4);
      height: pxToRem(32);
      padding: 0 pxToRem(2);
      transition: background-color 0.15s linear;
      width: pxToRem(32);

      &:hover,
      &:focus {
        background-color: $color-gray-light;
      }

      &:before {
        background-color: transparent;
        bottom: 0;
        content: "";
        display: inline-block;
        position: fixed;
        left: pxToRem(-6);
        transition: width 0.1s ease-in-out, left 0.1s ease-in-out,
        background-color 0.1s ease-in-out;
        @include transform(left left);
        top: 0;
        width: 0;
      }

      &.isActive {
        &:before {
          background-color: rgba($color-dark, 0.5);
          left: 0;
          right: 0;
          width: 100%;
          z-index: 112;
        }
      }
    }

    &_menuIcon {
    }

    &_content {
      max-width: pxToRem(1280);
      margin: 0 auto;
      position: relative;
    }

    // customização das classes bootstrap
    .navbar-brand {
      line-height: 0;
      margin: 0;
      padding: 0;
    }

    @media (min-width: pxToRem(420)) {
      &_logo {
        width: pxToRem(84);
      }
    }

    @media (min-width: pxToRem(568)) {
      &_logo {
        height: pxToRem(64);
        width: pxToRem(112);
      }
    }

    @media print {
      display: none;
    }
  }

  .logo_rei {
    width: 70px;
    height: 45px;
  }
</style>
